// extracted by mini-css-extract-plugin
export default {"formTitle":"style_formTitle__VuSGm"};